import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
type JourneysIconProps = {
  className?: string;
};

/** The Journeys product mark — a branching-path glyph. */
export const JourneysIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8 3L4 7l4 4M4 7h16M16 21l4-4-4-4M20 17H4" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};